/**
 * Shared Glide Data Grid theme configuration
 * Primary teal theme matching EVA design system
 */
export const GLIDE_GRID_THEME = {
  baseFontStyle: "13px",
  editorFontSize: "13px",
  headerFontStyle: "600 14px",
  fontFamily: "Bai Jamjuree",
  // Selection colors - primary teal theme
  accentColor: "#00c7b1",
  accentLight: "rgba(0, 199, 176, 0.15)",
  // Header when cell in column is selected - use lighter teal for dark text readability
  bgHeaderHasFocus: "#b2f0e8",
  textHeaderSelected: "#ffffff",
  // Cell selection
  bgCellMedium: "rgba(0, 199, 177, 0.08)"
} as const;
